import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

const unwrapData = (response) => response?.data || response

export const getDockwalkSummary = (marinaSlug, date) => {
  return queryApi(`/manage/${marinaSlug}/dockwalk_summary?date=${date}`).then(
    unwrapData
  )
}

export const getDockwalkActivityLog = (marinaSlug, date, params = {}) => {
  return queryApi(
    `/manage/${marinaSlug}/dockwalk_summary/activity_log${buildQueryString({
      date,
      ...params,
    })}`
  )
}

export const getDockwalkAuditTrail = (marinaSlug, date, params = {}) => {
  return queryApi(
    `/manage/${marinaSlug}/dockwalk_summary/audit_trail${buildQueryString({
      date,
      ...params,
    })}`
  )
}

export const updateDockwalkFlag = (marinaSlug, id, isFlagged) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/space_notes/${id}`,
    method: "PATCH",
    data: { is_flagged: isFlagged },
  })
}
